export const GET_MASTER_DATA = 'GET_MASTER_DATA';
export const SET_MASTER_DATA = 'SET_MASTER_DATA';
export const GET_KPIS_DATA = 'GET_KPIS_DATA';
export const SET_KPI_LOADING = 'SET_KPI_LOADING';
export const GET_PACKAGE_LIST_MASTER = 'GET_PACKAGE_LIST_MASTER';
export const SET_PACKAGE_LIST_MASTER = 'SET_PACKAGE_LIST_MASTER';
export const SET_PACKAGE_LIST_LOADING_MASTER = 'SET_PACKAGE_LIST_LOADING_MASTER';
